/**
 * Image Search Agent - Evaluation Section
 * Section 5: Final Reminders, Explanations, Evaluation Criteria
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { getSharedVariable } from '../../../../prompts';
import { IMAGE_SEARCH_PROMPT_KEYS } from './variables';
class ImageSearchEvaluationSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = IMAGE_SEARCH_PROMPT_KEYS.evaluation;
        this.fallbackContent = `## Example Workflow

### Step 1: Retrieve logo variants
\`\`\`json
{
  "companyDomain": "microsoft.com",
  "assetType": "logo",
  "requirementId": "A"
}
\`\`\`

### Step 2: Select best variant and submit
\`\`\`json
{
  "results": [
    {
      "requirementId": "A",
      "relevantResults": {
        "assets": [
          { "id": "logo_abc12", "note": "Microsoft dark_logo variant, horizontal" }
        ]
      },
      "rationale": "Selected dark variant for light background"
    }
  ],
  "summary": "Found requested assets"
}
\`\`\`

---

## Rules

1. Call retrieve_brandfetch ONCE - it retrieves ALL variants
2. ALWAYS retrieve before submitting (search alone doesn't download)
3. Use the EXACT assetId from retrieve tools
4. Call submitResults ONCE after ALL requirements fulfilled
5. Select variant based on preferredBackground or target background:
   - Light background / preferredBackground="light_bg" → dark_logo/dark_icon
   - Dark background / preferredBackground="dark_bg" → light_logo/light_icon
6. Select shape based on preferredShape when provided:
   - preferredShape="square" → prefer icon/symbol variants
   - preferredShape="horizontal" → prefer logo variants with text
7. If no variant matches the preference, STILL return the best available — note the mismatch in the asset note

{{securityWarnings}}`;
    }
}
const evaluationSection = new ImageSearchEvaluationSection();
/**
 * Get the evaluation section.
 * Uses Keywords AI if available, otherwise falls back to code.
 * Supports {{securityWarnings}} variable replacement.
 */
export function getEvaluationSection() {
    return evaluationSection.getContentWithVariables({
        securityWarnings: getSharedVariable('securityWarnings'),
    });
}
/**
 * Export constant for backwards compatibility
 */
export const IMAGE_SEARCH_EVALUATION = evaluationSection.getFallbackContent();
